export type FieldType =
  | 'radio'
  | 'checkbox'
  | 'select'
  | 'multiselect'
  | 'text'
  | 'number';

export type FormFieldValue =
  | string
  | number
  | boolean
  | string[]
  | Array<string | number>
  | undefined;

export const QualificationType = {
  INCOME: 'self_attestation_qualifying_income',
  PROGRAM: 'self_attestation_assistance_programs',
  INCOME_REJECTED: 'self_attestation_qualifying_income_rejected',
  MN_COMBINED: 'self_attestation_mn_income_program_combined',
} as const;

export type QualificationTypeValue =
  typeof QualificationType[keyof typeof QualificationType];

export interface FieldVisibilityRule {
  [fieldName: string]: string | string[];
}

export interface DynamicTextConfig {
  [placeholder: string]: {
    source: 'field' | 'variable';
    fieldName?: string;
    variableName?: string;
    fallback?: string;
  };
}

export interface FieldDependencyConfig {
  allOf?: string[];
  anyOf?: string[];
}

export interface FieldOption {
  value: string;
  label: string;
  enableWhen?: FieldDependencyConfig;
  interpolations?: DynamicTextConfig;
  listItems?: string[];
}

export interface DisclaimerStyle {
  fontWeight?: number | string;
  fontSize?: string;
  color?: string;
  fontStyle?: 'normal' | 'italic' | 'oblique';
}

export interface FormField {
  name: string;
  type: FieldType;
  label: string;
  description?: string;
  required?: boolean;
  options?: FieldOption[];
  disclaimer?: string[];
  disclaimerStyle?: DisclaimerStyle;
  placeholder?: string;
  header?: string;
  minSelections?: number;
  showWhen?: FieldVisibilityRule;
  enableWhen?: FieldDependencyConfig;
  interpolations?: DynamicTextConfig;
  validation?: {
    pattern?: string;
    message?: string;
  };
}

export interface IncomeLimitData {
  houseOccupancy: number;
  householdIncome: number;
}

export type IncomeLimits = Record<string, string[] | IncomeLimitData[]>;

export interface LmiContractConfig {
  title: string;
  description?: string;
  lmiProofCategory: 'proof_docs' | 'qualifying_programs';
  contractTag?: string;
  requiresDocumentUpload?: boolean;
  fields: FormField[];
  contractLink: {
    preText: string;
    postText: string;
  };
  stateSpecificData?: {
    defaultCounties?: readonly string[];
    [key: string]: unknown;
  };
  additionalData?: {
    counties?: string[];
    incomeLimits?: IncomeLimits;
    qualifyingPrograms?: string[];
    proofDocuments?: Record<string, string | string[]> | null;
    customerName?: string;
  };
}
